import React from "react";
import { Route, Switch } from "react-router-dom";
import WarrantyList from "./components/WarrantyList";
import WarrantyForm from "./components/WarrantyForm";
import WarrantyEdit from "./components/WarrantyEdit";
import WarrantyExport from "./components/WarrantyExport";

const defaults = {
    WarrantyForm,
    WarrantyList,
    WarrantyEdit,
    WarrantyExport,
};

export default (options = {}) => {
    const components = { ...defaults, ...options };
    const { WarrantyForm, WarrantyList, WarrantyEdit /* , WarrantyExport */ } =
        components;

    return {
        routes: [
            {
                path: "/warranty-registrations",
                render: ({ match }) => (
                    <Switch>
                        <Route
                            path={`${match.url}`}
                            exact
                            component={WarrantyList}
                        />
                        <Route
                            path={`${match.url}/export`}
                            exact
                            component={WarrantyExport}
                        />
                        <Route path={`${match.url}/:warrantyId`} exact>
                            {(props) => (
                                <WarrantyEdit
                                    {...props}
                                    WarrantyForm={WarrantyForm}
                                />
                            )}
                        </Route>
                    </Switch>
                ),
            },
        ],
    };
};
